import React from "react";
import { useMsal } from "@azure/msal-react";
import { DefaultButton } from "@fluentui/react";

export const SignOutButton = () => {
    const { instance } = useMsal();

    const handleSignOut = (): void => {
        instance.logoutPopup({
            postLogoutRedirectUri: "/",
            mainWindowRedirectUri: "/",
        });
    };

    return (
        <DefaultButton text="Sign out" onClick={handleSignOut} />
    );
};
